document.addEventListener('DOMContentLoaded', function () {

/* =====================================================
   STYLES
===================================================== */

const drawerStyles = `
<style>
.firmness-filter {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.firmness-btn {
  padding: 8px 14px;
  border-radius: 999px;
  border: none;
  background: #E6D3B3;
  color: #ffffff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: 0.2s ease;
}

.firmness-btn:hover {
  background: #A8864F;
}

.firmness-btn.active {
  background: #C2A46F;
  transform: scale(1.05);
}

.mattress-drawer-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  opacity: 0;
  visibility: hidden;
  transition: 0.3s;
  z-index: 9998;
}

.mattress-drawer-overlay.active {
  opacity: 1;
  visibility: visible;
}

.mattress-drawer {
  position: fixed;
  top: 0;
  right: -480px;
  width: 480px;
  max-width: 90vw;
  height: 100%;
  background: #fff;
  box-shadow: -2px 0 15px rgba(0,0,0,0.15);
  transition: 0.3s ease;
  z-index: 9999;
  display: flex;
  flex-direction: column;
}

.mattress-drawer.active {
  right: 0;
}

.mattress-drawer-header {
  padding: 20px;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mattress-drawer-close {
  width: 34px;
  height: 34px;
  background: #C2A46F;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
  margin-top: 50px;
  transition: 0.2s ease;
}

.mattress-drawer-close:hover {
  background: #A8864F;
}

.mattress-drawer-content {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}

.mattress-product {
  background: #FFF8F2;
  border-radius: 14px;
  padding: 18px;
  margin-bottom: 22px;
  box-shadow: 0 6px 18px rgba(0,0,0,0.08);
}

.mattress-card {
  display: flex;
  gap: 16px;
  align-items: center;
}

.mattress-thumb img {
  width: 95px;
  height: 95px;
  object-fit: cover;
  border-radius: 10px;
}

.mattress-info h3 {
  margin: 0 0 6px;
  font-size: 17px;
}

.price-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.price-was {
  text-decoration: line-through;
  color: #888;
  font-size: 14px;
}

.price-now {
  font-weight: bold;
  font-size: 16px;
}

.price-save {
  color: #8a1d45;
  font-weight: 600;
  font-size: 14px;
}

.mattress-info .add-btn {
  background: #C2A46F;
  color: #ffffff;
  border: none;
  padding: 10px 16px;
  cursor: pointer;
  border-radius: 999px;
  margin-top: 8px;
  font-weight: 600;
  transition: 0.2s ease;
}

.mattress-info .add-btn:hover {
  background: #A8864F;
}

.mattress-info .add-btn.added {
  background: #2e7d32;
}

.details-toggle {
  background: #000;
  color: #fff;
  border: none;
  padding: 8px 14px;
  border-radius: 999px;
  margin-top: 6px;
  cursor: pointer;
}

.mattress-details {
  display: none;
  margin-top: 16px;
}

.mattress-details.active {
  display: block;
}

.mattress-details img {
  width: 100%;
  border-radius: 12px;
  margin-bottom: 10px;
}

.mattress-drawer-header-text {
  display: flex;
  flex-direction: column;
}

.mattress-drawer-size-badge {
  display: inline-block;
  align-self: flex-start;
  margin-top: 6px;
  padding: 3px 12px;
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
  background: #C2A46F;
  border-radius: 999px;
}
</style>
`;

document.body.insertAdjacentHTML('beforeend', drawerStyles);

/* =====================================================
   DRAWER HTML
===================================================== */

document.body.insertAdjacentHTML('beforeend', `
<div class="mattress-drawer-overlay"></div>
<div class="mattress-drawer">
  <div class="mattress-drawer-header">
    <span class="mattress-drawer-header-text">
      Select Mattress and Save
      <span class="mattress-drawer-size-badge" id="mattress-drawer-size-badge"></span>
    </span>
    <div class="mattress-drawer-close">✕</div>
  </div>
  <div class="mattress-drawer-content">
    Loading mattresses...
  </div>
</div>
`);

const drawer = document.querySelector('.mattress-drawer');
const overlay = document.querySelector('.mattress-drawer-overlay');
const content = document.querySelector('.mattress-drawer-content');
const closeBtn = document.querySelector('.mattress-drawer-close');

let currentSize = '';
let currentFirmness = 'All';
let allProducts = [];

function openDrawer() {
  const badge = document.getElementById('mattress-drawer-size-badge');
  const size = getSelectedBedSizeDisplay();
  if (badge) badge.textContent = size ? ('Size: ' + size) : '';
  drawer.classList.add('active');
  overlay.classList.add('active');
}

function closeDrawer() {
  drawer.classList.remove('active');
  overlay.classList.remove('active');
}

overlay.addEventListener('click', closeDrawer);
closeBtn.addEventListener('click', closeDrawer);

/* =====================================================
   HELPERS
===================================================== */

function cleanText(value) {
  return String(value || '')
    .toLowerCase()
    .replace(/-/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function getSelectedBedSize() {
  const sizeWords = [
    'small single',
    'single',
    'small double',
    'double',
    'king',
    'super king',
    '2ft6',
    '3ft',
    '4ft',
    '4ft6',
    '5ft',
    '6ft'
  ];

  const selects = document.querySelectorAll('select');

  for (const select of selects) {
    const text = cleanText(select.options[select.selectedIndex]?.text || select.value);
    const name = cleanText(select.name || select.id || select.getAttribute('aria-label') || '');

    if (name.includes('size') || sizeWords.some(word => text.includes(word))) {
      return text;
    }
  }

  const checkedInputs = document.querySelectorAll('input[type="radio"]:checked');

  for (const input of checkedInputs) {
    const label = document.querySelector(`label[for="${input.id}"]`);
    const text = cleanText(label?.innerText || input.value);

    if (sizeWords.some(word => text.includes(word))) {
      return text;
    }
  }

  return '';
}

function getSelectedBedSizeDisplay() {
  const sizeWords = [
    'small single',
    'single',
    'small double',
    'double',
    'king',
    'super king',
    '2ft6',
    '3ft',
    '4ft',
    '4ft6',
    '5ft',
    '6ft'
  ];

  const selects = document.querySelectorAll('select');

  for (const select of selects) {
    const raw = select.options[select.selectedIndex]?.text || select.value || '';
    const text = raw.replace(/\s+/g, ' ').trim();
    const name = cleanText(select.name || select.id || select.getAttribute('aria-label') || '');

    if (name.includes('size') || sizeWords.some(word => cleanText(text).includes(word))) {
      return text;
    }
  }

  const checkedInputs = document.querySelectorAll('input[type="radio"]:checked');

  for (const input of checkedInputs) {
    const label = document.querySelector(`label[for="${input.id}"]`);
    const raw = label?.innerText || input.value || '';
    const text = raw.replace(/\s+/g, ' ').trim();

    if (sizeWords.some(word => cleanText(text).includes(word))) {
      return text;
    }
  }

  return '';
}

// Returns a single canonical size key for a size string. Used for exact
// equality matching between the selected bed size and a mattress variant —
// substring matching is unsafe because, e.g. "4ft6" contains "4ft" and
// "small double" contains "double".
function canonicalSize(text) {
  const s = cleanText(text);

  // Unambiguous numeric markers take priority (check 4ft6 before 4ft).
  if (s.includes('2ft6') || s.includes('75cm')) return 'small_single';
  if (s.includes('4ft6') || s.includes('135cm')) return 'double';
  if (s.includes('4ft')  || s.includes('120cm')) return 'small_double';
  if (s.includes('3ft')  || s.includes('90cm'))  return 'single';
  if (s.includes('5ft')  || s.includes('150cm')) return 'king';
  if (s.includes('6ft')  || s.includes('180cm')) return 'super_king';

  // Word-based fallbacks (multi-word sizes before their substrings).
  if (s.includes('super king'))   return 'super_king';
  if (s.includes('small single')) return 'small_single';
  if (s.includes('small double')) return 'small_double';
  if (s.includes('king'))   return 'king';
  if (s.includes('double')) return 'double';
  if (s.includes('single')) return 'single';

  return s;
}

function priceToNumber(value) {
  // Shopify's /products.json endpoint returns prices as decimal currency
  // strings (e.g. "529.00"), NOT cents. Parse directly — never divide by 100.
  return parseFloat(value) || 0;
}

function getProductImage(product) {
  if (!product.images || !product.images.length) return '';
  return typeof product.images[0] === 'string'
    ? product.images[0]
    : product.images[0].src;
}

/* =====================================================
   LOAD PRODUCTS
===================================================== */

function loadMattresses(size) {
  currentSize = size || '';
  content.innerHTML = 'Loading mattresses...';

  fetch('/collections/mattresses/products.json?limit=50')
    .then(res => res.json())
    .then(data => {
      allProducts = data.products || [];
      renderProducts();
    })
    .catch(() => {
      content.innerHTML = 'Could not load mattresses.';
    });
}

/* =====================================================
   RENDER PRODUCTS
===================================================== */

function renderProducts() {

  const firmnessOptions = ['All', 'Soft', 'Medium', 'Medium firm', 'Firm', 'Extra firm'];

  let html = `<div class="firmness-filter">`;

  firmnessOptions.forEach(option => {
    html += `
      <button class="firmness-btn ${currentFirmness === option ? 'active' : ''}" 
              data-firmness="${option}">
        ${option}
      </button>
    `;
  });

  html += `</div>`;

  let productCount = 0;

  allProducts.forEach(product => {

    const selectedKey = canonicalSize(currentSize);

    const matchingVariant = product.variants.find(v => {

      const variantText = [
        v.title,
        v.option1,
        v.option2,
        v.option3
      ].join(' ');

      const sizeMatch = canonicalSize(variantText) === selectedKey;

      if (currentFirmness === 'All') {
        return sizeMatch;
      }

      const productTags = (product.tags || []).map(tag => tag.toLowerCase());

const tagToMatch = 'firmness-' + currentFirmness.toLowerCase().replace(' ', '-');

const firmnessMatch = productTags.includes(tagToMatch);

      return sizeMatch && firmnessMatch;

    });

    if (!matchingVariant) return;

    productCount++;

    const priceNow = priceToNumber(matchingVariant.price);
    const rawWas = matchingVariant.compare_at_price
      ? priceToNumber(matchingVariant.compare_at_price)
      : 0;

    // Only show a "was" price when it is genuinely higher than the current
    // price, so we never display an inverted or negative saving.
    const priceWas = rawWas > priceNow ? rawWas : null;

    const saving = priceWas
      ? (priceWas - priceNow).toFixed(2)
      : null;

    const image = getProductImage(product);

    html += `
      <div class="mattress-product" data-id="${matchingVariant.id}">
        <div class="mattress-card">
          <div class="mattress-thumb">
            ${image ? `<img src="${image}" alt="${product.title}">` : ''}
          </div>
          <div class="mattress-info">
            <h3>${product.title}</h3>

            ${priceWas ? `
              <div class="price-row">
                <span class="price-was">£${priceWas.toFixed(2)}</span>
                <span class="price-now">£${priceNow.toFixed(2)}</span>
                <span class="price-save">Save £${saving}</span>
              </div>
            ` : `
              <div class="price-now">£${priceNow.toFixed(2)}</div>
            `}

            <button class="details-toggle">More details</button>
            <button class="add-btn">Add Mattress</button>
          </div>
        </div>

        <div class="mattress-details">
          ${image ? `<img src="${image}" alt="${product.title}">` : ''}
          <div>${product.body_html || ''}</div>
        </div>
      </div>
    `;
  });

  if (productCount === 0) {
    html += `
      <p>No mattresses found for this size.</p>
      <p style="font-size:13px;color:#777;">Try changing the size or use the All firmness tab.</p>
    `;
  }

  content.innerHTML = html;

  attachInteractions();
}

/* =====================================================
   INTERACTIONS
===================================================== */

function attachInteractions() {

  document.querySelectorAll('.firmness-btn').forEach(btn => {
    btn.addEventListener('click', function(){
      currentFirmness = this.dataset.firmness;
      renderProducts();
    });
  });

  document.querySelectorAll('.mattress-product').forEach(product => {

    const addBtn = product.querySelector('.add-btn');
    const detailsBtn = product.querySelector('.details-toggle');
    const details = product.querySelector('.mattress-details');

    detailsBtn.addEventListener('click', function(e){
      e.stopPropagation();
      details.classList.toggle('active');
      this.innerText = details.classList.contains('active')
        ? 'Hide details'
        : 'More details';
    });

    addBtn.addEventListener('click', function(e){
      e.stopPropagation();

      const variantId = product.dataset.id;

      const mattressImg = product.querySelector('.mattress-thumb img');
      const mattressTitle = product.querySelector('.mattress-info h3');
      const mattressPriceEl = product.querySelector('.price-now');

      const selectedData = {
        id: variantId,
        title: mattressTitle ? mattressTitle.innerText : '',
        image: mattressImg ? mattressImg.src : '',
        price: mattressPriceEl ? mattressPriceEl.innerText : ''
      };

      addBtn.innerText = 'Adding...';
      addBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
  id: variantId,
  quantity: 1,
  properties: {
    "Firmness": currentFirmness
  }
})
      }).then(() => {

        addBtn.innerText = 'Added ✓';
        addBtn.classList.add('added');

        showSelectedMattress(selectedData);

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));

        setTimeout(closeDrawer, 800);
      });
    });

  });
}

/* =====================================================
   UPDATE UPSELL CARD
===================================================== */

let selectedMattressData = null;

function showSelectedMattress(data) {
  selectedMattressData = data;

  const defaultEl = document.getElementById('mattress-addon-default');
  const selectedEl = document.getElementById('mattress-addon-selected');
  const titleEl = document.getElementById('selected-mattress-title');
  const priceEl = document.getElementById('selected-mattress-price');
  const imgEl = document.getElementById('selected-mattress-img');

  if (!defaultEl || !selectedEl) return;

  titleEl.innerText = data.title;
  priceEl.innerText = data.price;
  imgEl.src = data.image;

  defaultEl.style.display = 'none';
  selectedEl.style.display = 'block';
}

function resetMattressCard() {
  selectedMattressData = null;

  const defaultEl = document.getElementById('mattress-addon-default');
  const selectedEl = document.getElementById('mattress-addon-selected');

  if (defaultEl) defaultEl.style.display = 'block';
  if (selectedEl) selectedEl.style.display = 'none';
}

/* =====================================================
   OPEN BUTTON + CHANGE / REMOVE
===================================================== */

document.addEventListener('click', function (event) {

  const button = event.target.closest('.mattress-addon-button');
  const changeBtn = event.target.closest('.mattress-addon-change');
  const removeBtn = event.target.closest('.mattress-addon-remove');

  if (changeBtn) {
    event.preventDefault();
    const selectedSize = getSelectedBedSize();
    loadMattresses(selectedSize);
    openDrawer();
    return;
  }

  if (removeBtn) {
    event.preventDefault();

    if (selectedMattressData && selectedMattressData.id) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: selectedMattressData.id,
          quantity: 0
        })
      }).then(() => {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      });
    }

    resetMattressCard();
    return;
  }

  if (!button) return;

  event.preventDefault();

  const selectedSize = getSelectedBedSize();

  loadMattresses(selectedSize);
  openDrawer();
});

});